export { default } from './CarrosEletricosDisclaimerBanner';
